exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Heading img {\n    vertical-align: middle;\n    margin-right: 1em;\n}\n\n.Heading h1 {\n    display: inline;\n    text-transform: uppercase;\n    font-size: 1rem;\n    color: #808080;\n    vertical-align: middle;\n}\n", ""]);

